import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import api from '../api';
import './ChangePasswordModal.css';

const SetPasswordModal = ({ isOpen, onClose }) => {
  const { user, completePasswordSetup } = useAuth();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);

    // Validation
    if (!password || !confirmPassword) {
      setError('All fields are required');
      return;
    }

    if (password.length < 6) {
      setError('Password must be at least 6 characters long');
      return;
    }

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    setLoading(true);

    try {
      const res = await api.post('/auth/set-password', {
        password
      });

      if (res.data.success) {
        setSuccess(true);
        setPassword('');
        setConfirmPassword('');
        // Mark password setup as complete
        completePasswordSetup();
        // Close modal after 2 seconds
        setTimeout(() => {
          onClose();
          setSuccess(false);
        }, 2000);
      }
    } catch (err) {
      const errorMessage = err.response?.data?.error || 'Failed to set password';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    // Don't allow closing - user must set password
    // Only allow closing after successful password setup
    if (success) {
      setPassword('');
      setConfirmPassword('');
      setError('');
      setSuccess(false);
      onClose();
    }
  };

  return (
    <div className="change-password-modal-overlay">
      <div className="change-password-modal-content" onClick={(e) => e.stopPropagation()}>
        {/* Remove close button - user must set password */}
        <h2>Set Your Password</h2>
        {success ? (
          <div className="change-password-success">
            <p>✓ Password set successfully!</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="change-password-form-group">
              <label htmlFor="password">New Password:</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                disabled={loading}
                autoFocus
                minLength={6}
              />
              <small>Must be at least 6 characters</small>
            </div>
            <div className="change-password-form-group">
              <label htmlFor="confirm-password">Confirm Password:</label>
              <input
                type="password"
                id="confirm-password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                disabled={loading}
                minLength={6}
              />
            </div>
            {error && <div className="change-password-error">{error}</div>}
            <button type="submit" disabled={loading} className="change-password-submit-btn">
              {loading ? 'Setting Password...' : 'Set Password'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default SetPasswordModal;

